import element from "../../dom/element"

export default async (url: string, name?: null | string): Promise<void> => {
  // make and click a temporary link to download the Blob
  const link = element("a")
  link.href = url
  if (name) {
    link.download = name
  }
  link.target = "_blank"
  link.click()
  link.remove()
}
